export default __webpack_public_path__ + "static/s09-6971b29cf3fb842ca5915a45c034701c.png";